/**
 * Converts an unknown thrown value into a readable message.
 *
 * Prefer an Error or message field; use JSON for plain objects so they don't
 * collapse to "[object Object]". This helper only formats values; callers
 * decide whether to report the error or log it at a lower level.
 */
export const serializeError = (value: unknown): string => {
	if (value instanceof Error) return value.message;
	if (typeof value === 'string') return value;

	if (value !== null && typeof value === 'object') {
		const message = (value as { message?: unknown }).message;
		if (typeof message === 'string' && message.length > 0) return message;

		try {
			return JSON.stringify(value) ?? '[unserializable object]';
		} catch {
			return '[unserializable object]';
		}
	}

	return String(value);
};
